import { Add } from "@mui/icons-material";
import {
  Button,
  FormControl,
  MenuItem,
  Pagination,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { EmptyState } from "components/EmptyState";
import TextIcon from "components/TextIcons";
import i18n from "i18n/i18n";
import { chunk } from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { maintenanceData } from "utils/dummy";
import {
  GetReminderValue,
  GetRepetitionValue,
  getIntervalsInMs,
} from "utils/helper";

import { ReactComponent as BuildSvg } from "assets/Svgs/Build.svg";
import { Link, useNavigate } from "react-router-dom";
import { useBoundStore } from "store/store";
import IconText from "components/IconText";

function Maintenance(props: any) {
  const lang: any = useBoundStore((state) => state.lang);

  const { machineData } = props;
  const navigate = useNavigate();

  //sorting functions
  function descendingComparator(a: any, b: any, orderBy: any) {
    if (b < a) {
      return -1;
    }
    if (b > a) {
      return 1;
    }
    return 0;
  }

  function getComparator(order: any, orderBy: any) {
    return order === "desc"
      ? (a: any, b: any) => descendingComparator(a, b, orderBy)
      : (a: any, b: any) => -descendingComparator(a, b, orderBy);
  }
  function stableSort(array: any, comparator: any) {
    const stabilizedThis = array.map((el: any, index: any) => [
      el.maintenancetask,
      index,
    ]);
    stabilizedThis.sort((a: any, b: any) => {
      const order = comparator(a[0].startingfrom, b[0].startingfrom);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el: any) => el[0]);
  }

  const headCells = [
    {
      id: "1",
      numeric: false,
      disablePadding: false,
      sortIcon: "show",
      label: i18n(lang).mt_title,
      color: "rgba(14, 63, 81, 1)",
    },
    {
      id: "2",
      numeric: false,
      disablePadding: false,
      label: i18n(lang).next_implementation,
      color: "rgba(14, 63, 81, 1)",
    },
    {
      id: "3",
      numeric: false,
      disablePadding: false,
      label: i18n(lang).repetition,
      color: "rgba(14, 63, 81, 1)",
    },
    {
      id: "4",
      numeric: false,
      disablePadding: false,
      label: i18n(lang).memory,
      color: "rgba(14, 63, 81, 1)",
    },
    {
      id: "5",
      numeric: false,
      disablePadding: false,
      sortIcon: "show",
      label: i18n(lang).category,
      color: "rgba(14, 63, 81, 1)",
    },
  ];

  function EnhancedTableHead(props: any) {
    const {
      classes,
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property: any) => (event: any) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{ color: headCell.color }}
            >
              {headCell.label}
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              ></TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("");
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [page, setPage] = React.useState(0);

  const [sortingArray, setsortingArray] = React.useState([]);

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: any) => {};

  let paginationchunks = chunk(
    props.machineData?.equipment?.hasmaintenancetask,
    rowsPerPage
  );

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage - 1);
  };

  function checkOverDue(ts: any) {
    if (ts > Date.now()) {
      return false;
    } else {
      return true;
    }
  }

  function handleNotificationClick(item: any) {
    const notificationnodeid = item.nodeid;

    localStorage.setItem("notification-nodeid", item.nodeid);
    localStorage.setItem(
      "chatroomnodeid",
      item.haschatroom?.[0]?.chatroom.nodeid
    );
  }

  return (
    <>
      <div>
        <div className="MO_maintenance">
          <div style={{ margin: 0 }}>
            <Typography className="boldHeading">
              {i18n(lang)?.maintenance}
            </Typography>
          </div>

          <div>
            <Button
              variant="contained"
              startIcon={<Add />}
              sx={{ backgroundColor: "var(--primary-color)" }}
              onClick={() => {
                navigate("/create-maintenance", {
                  state: { equipment: machineData?.equipment },
                });
              }}
            >
              {i18n(lang)?.new_maintenance}
            </Button>
          </div>
        </div>
        <div className="MO_maintenance_desc">
          {i18n(lang)?.maintenance_desc}
        </div>
        <Table className="routineMaintenanceTable">
          <EnhancedTableHead
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={machineData?.equipment?.hasmaintenancetask?.length}
          />

          <TableBody>
            {machineData?.equipment?.hasmaintenancetask?.length > 0
              ? (rowsPerPage > 0
                  ? stableSort(
                      machineData?.equipment?.hasmaintenancetask,
                      getComparator(order, orderBy)
                    ).slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : machineData?.equipment?.hasmaintenancetask
                ).map((i: any, k: any) => {
                  // let nodeId;
                  // let targetNotification = machineData?.equipment
                  //   ?.hasnotification
                  //   ? machineData?.equipment?.hasnotification.filter(
                  //       (noti: any) => {
                  //         return (
                  //           noti?.notification?.hasmaintenancetask &&
                  //           noti?.notification?.hasmaintenancetask[0]
                  //             ?.maintenancetask?.nodeid === i.nodeid
                  //         );
                  //       }
                  //     )
                  //   : [];

                  let x = i.nextdueat;

                  const today =
                    moment(new Date().setHours(0, 0, 0, 0)).unix() * 1000;

                  if (
                    i.repetitioninterval !== "onetime" &&
                    i.repetitioninterval !== null &&
                    i?.repetitioninterval !== undefined &&
                    (i.triggertype === "time" ||
                      i.triggertype === null ||
                      i.triggertype === "")
                  ) {
                    while (true) {
                      if (i?.repetitioninterval) {
                        let x1 = x - getIntervalsInMs(i.repetitioninterval);
                        if (x1 < today) {
                          break;
                        } else {
                          x = x1;
                        }
                      }
                    }
                  } else {
                    if (i.nextdueat === -1) {
                      x = i.startingfrom;
                    }
                  }

                  return (
                    <TableRow key={k}>
                      <TableCell
                        component="th"
                        scope="row"
                        style={{
                          color: "var(--primary-second-color)",
                          width: "30%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          navigate("/edit-maintenance", {
                            state: { maintenancetask: i, edit: true },
                          });
                        }}
                      >
                        {i?.title}
                      </TableCell>

                      <TableCell>
                        {moment(x).format("DD.MM.YYYY")}
                        {/*                      
                        {targetNotification.length === 0 ? (
                          <div
                            key={k}
                            className="bxShadow newCalenderPill"
                            style={{
                              border: checkOverDue(i.startingfrom)
                                ? "1px solid #FF3D00"
                                : "1px solid rgba(0, 0, 0, 0.12)",
                            }}
                          >
                            <div
                              className="header"
                              style={{
                                textDecorationLine:
                                  targetNotification[0]?.notification.status ===
                                  2
                                    ? "line-through"
                                    : "",
                              }}
                            >
                              {moment(i.startingfrom).format("DD.MM.YYYY")}
                            </div>

                            <IconText
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                              iconStyle={{ transform: "" }}
                              icon={
                                <svg
                                  width="12"
                                  height="15"
                                  viewBox="0 0 12 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4 10.5C3.53333 10.5 3.13889 10.3389 2.81667 10.0166C2.49444 9.69442 2.33333 9.29998 2.33333 8.83331C2.33333 8.36665 2.49444 7.9722 2.81667 7.64998C3.13889 7.32776 3.53333 7.16665 4 7.16665C4.46667 7.16665 4.86111 7.32776 5.18333 7.64998C5.50556 7.9722 5.66667 8.36665 5.66667 8.83331C5.66667 9.29998 5.50556 9.69442 5.18333 10.0166C4.86111 10.3389 4.46667 10.5 4 10.5ZM1.33333 14.1666C0.966667 14.1666 0.652778 14.0361 0.391667 13.775C0.130556 13.5139 0 13.2 0 12.8333V3.49998C0 3.13331 0.130556 2.81942 0.391667 2.55831C0.652778 2.2972 0.966667 2.16665 1.33333 2.16665H2V1.49998C2 1.31109 2.06389 1.15276 2.19167 1.02498C2.31944 0.897202 2.47778 0.833313 2.66667 0.833313C2.85556 0.833313 3.01389 0.897202 3.14167 1.02498C3.26944 1.15276 3.33333 1.31109 3.33333 1.49998V2.16665H8.66667V1.49998C8.66667 1.31109 8.73056 1.15276 8.85833 1.02498C8.98611 0.897202 9.14444 0.833313 9.33333 0.833313C9.52222 0.833313 9.68056 0.897202 9.80833 1.02498C9.93611 1.15276 10 1.31109 10 1.49998V2.16665H10.6667C11.0333 2.16665 11.3472 2.2972 11.6083 2.55831C11.8694 2.81942 12 3.13331 12 3.49998V12.8333C12 13.2 11.8694 13.5139 11.6083 13.775C11.3472 14.0361 11.0333 14.1666 10.6667 14.1666H1.33333ZM1.33333 12.8333H10.6667V6.16665H1.33333V12.8333ZM1.33333 4.83331H10.6667V3.49998H1.33333V4.83331Z"
                                    fill="black"
                                    fillOpacity="0.87"
                                  />
                                </svg>
                              }
                              text={
                                checkOverDue(i.startingfrom)
                                  ? i18n(lang).overdue
                                  : i18n(lang).planned
                              }
                              textColor={
                                checkOverDue(i.startingfrom)
                                  ? "#FF3D00"
                                  : "rgba(0, 0, 0, 0.5)"
                              }
                            />
                          </div>
                        ) : (
                          <Link
                            to="/notification-details"
                            state={{
                              nodeid:
                                targetNotification[0]?.notification.nodeid,
                              from: "maintenance",
                            }}
                            onClick={() =>
                              handleNotificationClick(
                                targetNotification[0]?.notification
                              )
                            }
                          >
                            <div
                              key={k}
                              className="bxShadow newCalenderPill"
                              style={{
                               
                                marginLeft: "2px",
                                marginTop: "0px",
                                border:
                                  checkOverDue(
                                    i.startingfrom
                                  
                                  ) && targetNotification[0]?.notification.status !== 2
                                    ? "1px solid  #FF3D00"
                                    : targetNotification[0]?.notification.status === 2
                                    ? "1px solid #0000001F"
                                    : "1px solid #6FA03B",
                              }}
                            >
                              <div
                                className="header"
                                style={{
                                  textDecorationLine:
                                    targetNotification[0]?.notification
                                      .status === 2
                                      ? "line-through"
                                      : "",
                                }}
                              >
                                {moment(i.startingfrom).format("DD.MM.YYYY")}
                              </div>

                              {targetNotification[0]?.notification.status ===
                              2 ? (
                                <TextIcon
                                  svg={
                                    <svg
                                      width="14"
                                      height="15"
                                      viewBox="0 0 14 15"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M6.06634 8.70004L4.61634 7.25004C4.49412 7.12782 4.34145 7.0696 4.15834 7.07537C3.97479 7.08071 3.8219 7.14449 3.69967 7.26671C3.57745 7.38893 3.51634 7.54449 3.51634 7.73337C3.51634 7.92226 3.57745 8.07782 3.69967 8.20004L5.59967 10.1C5.7219 10.2223 5.87745 10.2834 6.06634 10.2834C6.25523 10.2834 6.41079 10.2223 6.53301 10.1L10.3163 6.31671C10.4386 6.19449 10.497 6.0416 10.4917 5.85804C10.4859 5.67493 10.4219 5.52226 10.2997 5.40004C10.1775 5.27782 10.0219 5.21671 9.83301 5.21671C9.64412 5.21671 9.48856 5.27782 9.36634 5.40004L6.06634 8.70004ZM6.99967 14.1667C6.07745 14.1667 5.21079 13.9916 4.39967 13.6414C3.58856 13.2916 2.88301 12.8167 2.28301 12.2167C1.68301 11.6167 1.20812 10.9112 0.858341 10.1C0.508119 9.28893 0.333008 8.42226 0.333008 7.50004C0.333008 6.57782 0.508119 5.71115 0.858341 4.90004C1.20812 4.08893 1.68301 3.38337 2.28301 2.78337C2.88301 2.18337 3.58856 1.70826 4.39967 1.35804C5.21079 1.00826 6.07745 0.833374 6.99967 0.833374C7.9219 0.833374 8.78856 1.00826 9.59967 1.35804C10.4108 1.70826 11.1163 2.18337 11.7163 2.78337C12.3163 3.38337 12.7912 4.08893 13.141 4.90004C13.4912 5.71115 13.6663 6.57782 13.6663 7.50004C13.6663 8.42226 13.4912 9.28893 13.141 10.1C12.7912 10.9112 12.3163 11.6167 11.7163 12.2167C11.1163 12.8167 10.4108 13.2916 9.59967 13.6414C8.78856 13.9916 7.9219 14.1667 6.99967 14.1667ZM6.99967 12.8334C8.47745 12.8334 9.7359 12.314 10.775 11.2754C11.8137 10.2363 12.333 8.97782 12.333 7.50004C12.333 6.02226 11.8137 4.76382 10.775 3.72471C9.7359 2.68604 8.47745 2.16671 6.99967 2.16671C5.5219 2.16671 4.26367 2.68604 3.22501 3.72471C2.1859 4.76382 1.66634 6.02226 1.66634 7.50004C1.66634 8.97782 2.1859 10.2363 3.22501 11.2754C4.26367 12.314 5.5219 12.8334 6.99967 12.8334Z"
                                        fill="black"
                                        fillOpacity="0.5"
                                      />
                                    </svg>
                                  }
                                  text={"Durchgeführt"}
                                  textColor={"gray"}
                                />
                              ) : (
                                <TextIcon
                                  svg={
                                    checkOverDue(i.startingfrom) ? (
                                      <svg
                                        width="12"
                                        height="13"
                                        viewBox="0 0 12 13"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M9.91667 12.0833C9.69444 12.0833 9.48333 12.0418 9.28333 11.9587C9.08333 11.8751 8.9 11.75 8.73333 11.5833L5.4 8.23333C5.17778 8.32222 4.95289 8.38889 4.72533 8.43333C4.49733 8.47778 4.25556 8.5 4 8.5C2.88889 8.5 1.94444 8.11111 1.16667 7.33333C0.388889 6.55556 0 5.61111 0 4.5C0 4.1 0.0555555 3.71933 0.166667 3.358C0.277778 2.99711 0.433333 2.65556 0.633333 2.33333L3.06667 4.76667L4.26667 3.56667L1.83333 1.13333C2.15556 0.933333 2.49711 0.777778 2.858 0.666667C3.21933 0.555556 3.6 0.5 4 0.5C5.11111 0.5 6.05556 0.888889 6.83333 1.66667C7.61111 2.44444 8 3.38889 8 4.5C8 4.75556 7.97778 4.99711 7.93333 5.22467C7.88889 5.45267 7.82222 5.67778 7.73333 5.9L11.1 9.23333C11.2667 9.4 11.3918 9.58333 11.4753 9.78333C11.5584 9.98333 11.6 10.1944 11.6 10.4167C11.6 10.6389 11.5556 10.8527 11.4667 11.058C11.3778 11.2638 11.2556 11.4444 11.1 11.6C10.9333 11.7667 10.75 11.8889 10.55 11.9667C10.35 12.0444 10.1389 12.0833 9.91667 12.0833ZM9.7 10.6667C9.75555 10.7222 9.83067 10.7473 9.92533 10.742C10.0196 10.7362 10.0944 10.7056 10.15 10.65C10.2056 10.5944 10.2333 10.5196 10.2333 10.4253C10.2333 10.3307 10.2056 10.2556 10.15 10.2L6.1 6.16667C6.3 5.94444 6.44444 5.686 6.53333 5.39133C6.62222 5.09711 6.66667 4.8 6.66667 4.5C6.66667 3.83333 6.45289 3.25267 6.02533 2.758C5.59733 2.26378 5.06667 1.96667 4.43333 1.86667L5.66667 3.1C5.8 3.23333 5.86667 3.38889 5.86667 3.56667C5.86667 3.74444 5.8 3.9 5.66667 4.03333L3.53333 6.16667C3.4 6.3 3.24444 6.36667 3.06667 6.36667C2.88889 6.36667 2.73333 6.3 2.6 6.16667L1.36667 4.93333C1.46667 5.56667 1.764 6.09711 2.25867 6.52467C2.75289 6.95267 3.33333 7.16667 4 7.16667C4.28889 7.16667 4.57778 7.12222 4.86667 7.03333C5.15556 6.94444 5.41667 6.80556 5.65 6.61667L9.7 10.6667Z"
                                          fill="#FF3D00"
                                        />
                                      </svg>
                                    ) : (
                                      <svg
                                        width="12"
                                        height="13"
                                        viewBox="0 0 12 13"
                                        fill="#6FA03B"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M9.91667 12.0833C9.69444 12.0833 9.48333 12.0418 9.28333 11.9587C9.08333 11.8751 8.9 11.75 8.73333 11.5833L5.4 8.23333C5.17778 8.32222 4.95289 8.38889 4.72533 8.43333C4.49733 8.47778 4.25556 8.5 4 8.5C2.88889 8.5 1.94444 8.11111 1.16667 7.33333C0.388889 6.55556 0 5.61111 0 4.5C0 4.1 0.0555555 3.71933 0.166667 3.358C0.277778 2.99711 0.433333 2.65556 0.633333 2.33333L3.06667 4.76667L4.26667 3.56667L1.83333 1.13333C2.15556 0.933333 2.49711 0.777778 2.858 0.666667C3.21933 0.555556 3.6 0.5 4 0.5C5.11111 0.5 6.05556 0.888889 6.83333 1.66667C7.61111 2.44444 8 3.38889 8 4.5C8 4.75556 7.97778 4.99711 7.93333 5.22467C7.88889 5.45267 7.82222 5.67778 7.73333 5.9L11.1 9.23333C11.2667 9.4 11.3918 9.58333 11.4753 9.78333C11.5584 9.98333 11.6 10.1944 11.6 10.4167C11.6 10.6389 11.5556 10.8527 11.4667 11.058C11.3778 11.2638 11.2556 11.4444 11.1 11.6C10.9333 11.7667 10.75 11.8889 10.55 11.9667C10.35 12.0444 10.1389 12.0833 9.91667 12.0833ZM9.7 10.6667C9.75555 10.7222 9.83067 10.7473 9.92533 10.742C10.0196 10.7362 10.0944 10.7056 10.15 10.65C10.2056 10.5944 10.2333 10.5196 10.2333 10.4253C10.2333 10.3307 10.2056 10.2556 10.15 10.2L6.1 6.16667C6.3 5.94444 6.44444 5.686 6.53333 5.39133C6.62222 5.09711 6.66667 4.8 6.66667 4.5C6.66667 3.83333 6.45289 3.25267 6.02533 2.758C5.59733 2.26378 5.06667 1.96667 4.43333 1.86667L5.66667 3.1C5.8 3.23333 5.86667 3.38889 5.86667 3.56667C5.86667 3.74444 5.8 3.9 5.66667 4.03333L3.53333 6.16667C3.4 6.3 3.24444 6.36667 3.06667 6.36667C2.88889 6.36667 2.73333 6.3 2.6 6.16667L1.36667 4.93333C1.46667 5.56667 1.764 6.09711 2.25867 6.52467C2.75289 6.95267 3.33333 7.16667 4 7.16667C4.28889 7.16667 4.57778 7.12222 4.86667 7.03333C5.15556 6.94444 5.41667 6.80556 5.65 6.61667L9.7 10.6667Z"
                                          fill="#6FA03B"
                                        />
                                      </svg>
                                    )
                                  }
                                  text={
                                    checkOverDue(i.startingfrom)
                                      ? i18n(lang).overdue
                                      : "Durchführbar"
                                  }
                                  textColor={
                                    checkOverDue(i.startingfrom)
                                      ? "#FF3D00"
                                      : "rgba(0, 0, 0, 0.5)"
                                  }
                                />
                              )}
                            </div>
                          </Link>
                        )} */}
                      </TableCell>

                      <TableCell align="left">
                        {GetRepetitionValue(i.repetitioninterval, lang)}
                      </TableCell>
                      <TableCell align="left">
                        {GetReminderValue(i.reminder, lang)}
                      </TableCell>
                      <TableCell align="left">
                        <div
                          style={{
                            lineHeight: "1.5",
                            boxShadow:
                              "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0)",
                            display: "block",
                            height: 18,
                            width: 123,
                            fontSize: 12,
                            letterSpacing: 0.4,
                            textAlign: "center",
                            borderRadius: 20,
                            background:
                              i?.hascategory &&
                              i?.hascategory[0]?.maintenancecategory?.colorcode,
                            fontWeight: "bold",
                            color: "#FFFFFF",
                          }}
                        >
                          {i?.hascategory &&
                            i?.hascategory[0]?.maintenancecategory?.name}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              : i18n(lang)?.no_maintenancetask}
          </TableBody>
        </Table>

        <div className="MO_customPagination">
          <div>
            {paginationchunks.length > 0 ? (
              <Pagination
                count={paginationchunks.length}
                shape="rounded"
                onChange={handleChangePage}
                hideNextButton={page === paginationchunks.length - 1}
                hidePrevButton={page === 0}
              />
            ) : (
              ""
            )}
          </div>
          <div>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows Per Page"
              >
                <MenuItem value={5}>5 {i18n(lang).rows_per_page}</MenuItem>
                <MenuItem value={10}>10 {i18n(lang).rows_per_page}</MenuItem>
                <MenuItem value={25}>25 {i18n(lang).rows_per_page}</MenuItem>
                <MenuItem value={50}>50 {i18n(lang).rows_per_page}</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
      </div>
    </>
  );
}

export default Maintenance;
